import { render, staticRenderFns } from "./VerticalHeading.vue?vue&type=template&id=b7049432&scoped=true"
import script from "./VerticalHeading.vue?vue&type=script&lang=ts"
export * from "./VerticalHeading.vue?vue&type=script&lang=ts"
import style0 from "./VerticalHeading.vue?vue&type=style&index=0&id=b7049432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7049432",
  null
  
)

export default component.exports